import React, { useState, useEffect } from 'react';
import ButtonComponent from '../components/ButtonComponent';
import { connect } from 'react-redux';
import InputComponent from '../components/fields/InputComponent'
const CorporateSignupSuccess = (props) => {

    //console.log(props.getSessionStorage)
    const [enabledCopied, setEnabledCopied] = useState(false)
    const [smartLink, setSmartLink] = useState('')
    useEffect(() => {
        // setSmartLink(`${window.location.origin}${getLocalizedUrl('/#/customer/join/')}${props.getConnectedResponse['transactionId']}`)
    }, []);


    const getLocalizedUrl = (url) => {
        const regexForLocale = /^[a-z]{2}[-][a-z]{2}$/;
        const regexForLocale2 = /^([a-z]{2})$/;
        let locale = window.location.pathname.split('/')[1];
        if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        if (regexForLocale.test(locale) || regexForLocale2.test(locale)) {
            return `/${locale}${url}`;
        } else {
            return url;
        }
    }

    // const smartLinkCheck = () => {

    //     if (props.getSessionStorage.smartLinks) {
    //         if (smartLink === '') {
    //             setSmartLink(getLocalizedUrl(`/#/customer/join/${JSON.parse(window.sessionStorage.getItem('prof-profile')).smartLinks.travelerLink}`))
    //         }
    //     }
    // }

    const addToProfile = () => {
        window.sessionStorage.setItem('corporateSignup', 'init')
        if(Object.keys(props.getSessionStorage).length > 0) {
        if (JSON.parse(window.sessionStorage.getItem('prof-profile')).smartLinks) {
            window.location.href = getLocalizedUrl(`/#/customer/join/${JSON.parse(window.sessionStorage.getItem('prof-profile')).smartLinks.travelAdminLink}`);
        }
    } else {
        window.location.href = getLocalizedUrl(`/#/customer/join/${JSON.parse(window.sessionStorage.getItem('smartLinks')).travelAdminLink}`);

    }
    }
    const copyLink = param => event => {
        navigator.clipboard.writeText(param);
        setEnabledCopied(true)
    };
    const backToStart = () => {
        window.location.href = '/'
    }
    return <>
        <div className="success-page-wrapper">
            <div className='success-tick'>
                <svg class="sas-icon search-icon sas-icon-cl--info-circle success-icon info-icon-sprite" role="presentation" >
                    <use href="#cl--check-circle"></use>
                </svg>
            </div>
            {props.getPartialSuccess && <>
                <div className="success-page-innder-title">{props.labels['corporate.signup.success.title']}</div>
                <div className='success-page-inner-content'>{props.labels['corporate.signup.success.pgae.description']}</div>
                {/* {props.labels['corporate.signup.success.desc']} */}

                <div className="successPage-button">
                    <ButtonComponent label="Not Now" onAction={backToStart} class="btn-secondary" />

                    <ButtonComponent label={Object.keys(props.getSessionStorage).length >0 ? props.labels['corporatesignup.connect.with.profile']  : props.labels['corporatesignup.register.login']} onAction={addToProfile} />
                </div>
                

                {/* <div className='inner-wrapper'>
                <div className="inner-title-success">{props.labels['corporate.signup.success.popup.title']}</div>
                {props.labels['corporate.signup.success.description']}

                <div className='smart-link-wrapper' >
                    <input type="text" value={smartLink} name="search" readonly className="smart-link-input " />
                    <button className='smart-link-copy-button' type="submit" id="link-copy" onClick={(e) => copyLink(smartLink)(e)} >{props.labels['corporate.signup.copy.link']}</button>
                    {enabledCopied && <><div  className="copied">{props.labels['corporate.signup.link.copied']}! </div></>}
                </div>
            </div> */}


            </>
            }
            {props.getPartialSuccess !== 'false' && <>
                <div className="success-page-inner-content">{props.labels['corporatesignup.partial.success']} </div>
                <ButtonComponent label={props.labels['corporate.signup.button.join']} onAction={backToStart} />
            </>
            }

        </div>
    </>
}



const mapStateFromReducer = (state) => ({
    labels: state.corporateSignupReducer.labels || {},
    getSessionStorage: state.corporateSignupReducer.getSessionStorage || {},
    getConnectedResponse: state.corporateSignupReducer.getConnectedResponse || {},
    getPartialSuccess: state.corporateSignupReducer.getPartialSuccess || {}
})

export default connect(
    mapStateFromReducer,
    null
)(CorporateSignupSuccess);